"use client";
import { useTranslations } from "next-intl";
import { ConnectionState } from "livekit-client";
import { JSX, useRef, useEffect, useState } from "react";
import { toastNotify } from "@client/components/ui/toast";
import { useIsRecording, useConnectionState } from "@livekit/components-react";

/** RecordingIndicator - Shows toast notifications for recording state changes */
export const RecordingIndicator = (): JSX.Element | null => {
  const t = useTranslations();
  const isRecording = useIsRecording();
  const connectionState = useConnectionState();
  const wasRecordingRef = useRef(false);
  const [isArmed, setIsArmed] = useState(false);

  // Arming logic: Only arm when we are fully connected and recording is OFF.
  // This prevents toasts on page load (when state syncs) or joining existing recording.
  useEffect(() => {
    if (connectionState === ConnectionState.Connected && !isRecording) {
      setIsArmed(true);
    }
  }, [connectionState, isRecording]);

  useEffect(() => {
    const wasRecording = wasRecordingRef.current;
    if (isRecording !== wasRecording) {
      wasRecordingRef.current = isRecording;
      if (isRecording && isArmed) {
        toastNotify.recordingStarted(t("toast.recordingStarted"), t("toast.recordingProgress"));
      }
    }
  }, [isRecording, isArmed, t]);

  /** No visible UI - handles toasts only */
  return null;
};
